import { BaseApiService } from './BaseApiService';
import { mapRecurse } from './utils';

export class FinancialIndicatorsService extends BaseApiService {
  modulesMap = {
    localAutonomy: 'localAutonomy',
    revenue: 'revenue',
    expenditure: 'expenditure',
  };

  modulesTitlesMap = {
    'Treguesit e Autonomisë Financiare': 'localAutonomy',
    'Treguesit e të ardhurave': 'revenue',
    'Treguesit e shpenzimeve': 'expenditure',
  };

  modulesTitlesMapEn = {
    'Indicators of Financial Autonomy': 'localAutonomy',
    'Revenue Indicators': 'revenue',
    'Expenditure Indicators': 'expenditure',
  };

  modulesByi18nKey = {
    localAutonomy: 'FINANCIAL_STATISTICS.LOCAL_AUTONOMY',
    revenue: 'FINANCIAL_STATISTICS.REVENUES',
    expenditure: 'FINANCIAL_STATISTICS.EXPENDITURES',
  };

  generateParams = (filters) => ({
    // data_level_id: filters.dataLevels?.length > 0 ? filters.dataLevels[0] : undefined,
    year_id: filters.year,
    government_entity_id: filters.municipality,
    formula_id: filters.formulaId,
    // compare: 'government_entity',
    period_type: 'annual',
    start_month: 1,
    end_month: 12,
  });

  constructor() {
    super();
    this.api = this.instance;
  }

  // GET /api/{module_name}/formulas?lang_id={lang_id}
  async getFormulas() {
    const response = await this.api.get(`/financial-indicator/formulas`);

    if (!response?.data) return [];

    return mapRecurse((x) => {
      return {
        description: x.title,
        value: x.id,
        children: x.nested_formulas,
      };
    }, response.data);
  }

  // GET api/financial-indicator/statistics?lang_id=,&government_entity_id=1&year_id=1&period_type=monthly&data_level_id=1&formula_id=1
  async expenditureChartData({ governmentEntityId, dataLevelId, formulaId, yearId, periodType }) {
    return this.api.get('/financial-indicator/statistics', {
      params: {
        government_entity_id: governmentEntityId,
        data_level_id: dataLevelId,
        formula_id: formulaId,
        year_id: yearId,
        period_type: periodType,
      },
    });
  }

  async getChartData(moduleValue, filterTypeValue, filters) {
    const endpoint = this.generateEndPointByModuleAndFilterType(moduleValue, filterTypeValue);
    const params = this.generateParams(filters);

    return this.api.get(endpoint, { params });
  }

  async years() {
    const { data: items } = await this.api.get(['financial-indicator', 'years'].join('/'));

    if (!items) return { data: [] };

    const data = items.map((item) => ({
      value: item.id,
      description: item.year,
    }));

    return { data };
  }

  async governmentEntities() {
    const { data: items } = await this.api.get(['financial-indicator', 'government-entities'].join('/'));

    if (!items) return { data: [] };

    const data = items.map((item) => ({
      value: item.id,
      description: item.entity,
    }));

    return { data };
  }

  async dictionary(moduleValue, formula_id) {
    const { data: items } = await this.api.get(['dictionary', 'terms', 'financial-indicator'].join('/'), {
      params: { formula_id },
    });

    if (!items) return { data: [] };

    const data = items.map((item) => ({
      value: item.id,
      term: item.term,
      description: item.meaning,
    }));

    return { data };
  }

  generateEndPointByModuleAndFilterType(moduleValue, filterTypeValue) {
    // checks
    const modulePath = 'financial-indicator';
    if (!modulePath) console.error('Module not exists. Module value: ', moduleValue);
    // end checks

    return [modulePath, 'statistics'].join('/');
  }

  searchTree(item, formulaId, path = []) {
    if (item.value === formulaId) {
      return item ? { item, path } : null;
    } else if (item.children != null) {
      let result = null;

      for (let i = 0; result == null && i < item.children.length; i++) {
        result = this.searchTree(item.children[i], formulaId, [...path, item]);
      }

      return result;
    }

    return null;
  }
}
